import React from "react";
import PropTypes from "prop-types";
import { NO_OP_FUNCTION } from "services/helpers";
import "./style.scss";

/**
 * Generates an individual radio button. This does not generate a group of linked buttons.
 * Offers more flexability in styling then the RadioButtons component.
 * First component is the actual button, second is the button users see, third is the label.
 * @param {Object} props properties from file
 * @returns {ReactElement}
 */
export const RadioButton = (props) => {
  const {
    id, name, checked, onChange, onClick, label, description
  } = props;

  return (
    <div className="RadioButton">
      <input
        id={id}
        type="radio"
        name={name}
        checked={checked}
        onChange={onChange}
        onClick={onClick}
        className="RadioButton__input"
      />
      <div className="RadioButton__button" />
      <label className="RadioButton__label" htmlFor={id}>
        {label}
      </label>

      {/* Only render a description if one has been provided */}
      {description && (
        <div className="RadioButton__description">{description}</div>
      )}
    </div>
  );
};

RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  label: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func
};

RadioButton.defaultProps = {
  name: "",
  label: "",
  description: "",
  onClick: NO_OP_FUNCTION,
  onChange: NO_OP_FUNCTION
};
